import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import './Elements.scss';
import AlertText from 'components/ui/AlertText/AlertText';
import { encuentraEmpleoResume, profileElements } from 'config/profile';
import { ProfileElement } from 'types';
import { openStampedResume } from 'utils/stampResumePhoto';

interface ElementsProps {
    isExpanded: boolean;
}

export default function Elements({ isExpanded }: ElementsProps) {
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const openEncuentraEmpleo = async () => {
        const file = encuentraEmpleoResume.url || encuentraEmpleoResume.path;
        setMessage('');
        if (!file) return;

        try {
            await openStampedResume({
                pdfUrl: file,
                photoUrl: encuentraEmpleoResume.photo || `${process.env.PUBLIC_URL || ''}/assets/img/photo/foto.png`,
                fileName: 'Curriculum - Encuentra Empleo.pdf',
            });
        } catch {
            window.open(file, '_blank');
        }
    };

    const openGeneratedCv = () => {
        setMessage('');
        navigate('/cv');
    };

    const handleAlert = () => {
        setMessage('Choose how you want to get the CV');
    };

    // Modificación del componente Element para ejecutar funciones o abrir enlaces
    const Element = ({ icon, label, name, url, action }: ProfileElement) => {

        const isAction = Boolean(url || action);

        const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();

            if (action === 'download-resume') {
                handleAlert();
                return;
            }

            if (url) {
                window.open(url, '_blank');
            }
        };

        const content = (
            <>
                <div className='icon'>
                    <i className={`fa-thin ${icon}`}></i>
                </div>
                <div className='text'>
                    <span className='label'>{label}</span>
                    <span className='name'>{name}</span>
                </div>
            </>
        );

        return (
            <Tooltip text={label} position='right' status={!isExpanded}>
                {isAction ? (
                    <a href={url || '#'} className="element selector" onClick={handleClick} translate="no">
                        {content}
                    </a>
                ) : (
                    <div className="element" translate="no">
                        {content}
                    </div>
                )}
            </Tooltip>
        );
    };

    return (
        <>
            <div className="sidebar-content scroll_element">
                {profileElements.map((element) => (
                    <Element key={element.label} {...element} />
                ))}
            </div>

            {message && (
                <AlertText
                    icon="fa-folder-user"
                    title="Download CV"
                    message={message}
                    setMessage={setMessage}
                    actions={[
                        ...(encuentraEmpleoResume.url || encuentraEmpleoResume.path ? [{
                            name: encuentraEmpleoResume.label,
                            hint: 'Official Encuentra Empleo format, with the profile photo',
                            image: encuentraEmpleoResume.image,
                            onClick: openEncuentraEmpleo,
                        }] : []),
                        {
                            name: 'Generate from portfolio',
                            hint: 'Printable CV generated from this portfolio',
                            icon: 'fa-wand-magic-sparkles',
                            onClick: openGeneratedCv,
                        },
                    ]}
                />
            )}
        </>
    );
}
